import React from "react";
import styled from "styled-components";
import gitLogo from "../assets/gitLogo.svg";

export const ToolbarHeader = () => {
  return (
    <ToolbarContainer>
      <Logo src={gitLogo} alt="LOGO" />
      <Path>C:/Users/KAMIL_WOJCIAK/CV</Path>
      <Buttons>
        <Button>-</Button>
        <Button>&#9633;</Button>
        <Button>x</Button>
      </Buttons>
    </ToolbarContainer>
  );
};

export default ToolbarHeader;

const ToolbarContainer = styled.div`
  background: white;
  border-bottom: 3px solid #282828;
  width: 114%;
  height: 50px;
  color: white;
  display: flex;
  align-items: center;
  padding: 0px 5%;
  overflow: hidden;
  flex-shrink: 0;
`;

const Logo = styled.img`
  width: 35px;
  height: 35px;
  flex-shrink: 0;
  margin-left: 30px;

  @media (max-width: 420px) {
    width: 25px;
    height: 25px;
  }
`;

const Path = styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: black;
  margin-left: 10px;
  flex-grow: 1;
  flex-shrink: 1;

  @media (max-width: 420px) {
    font-size: 0.8rem;
    font-weight: bold;
  }
`;

const Buttons = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end; /* Align buttons to the right */
  flex-shrink: 0;
  margin-right: 25px;
`;

const Button = styled.button`
  background-color: transparent;
  border: none;
  color: black;
  cursor: pointer;
  font-size: 1.3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 30px;
  flex-shrink: 0;

  @media (max-width: 420px) {
    font-size: 1rem;
  }

  @media (max-width: 400px) {
    display: none;
  }
`;
